module.exports = __webpack_public_path__ + "img/echr.255f8b6c.jpg";